import Phaser from 'phaser'

export class BlockSprite extends Phaser.GameObjects.Container {
  private img: Phaser.GameObjects.Image
  private ring: Phaser.GameObjects.Rectangle
  private size: number
  blockId = -1
  homeX = 0
  homeY = 0

  constructor(scene: Phaser.Scene, size: number) {
    super(scene)
    this.size = size
    this.ring = scene.add
      .rectangle(0, 0, size, size, 0xffffff, 0)
      .setStrokeStyle(Math.max(3, size * 0.06), 0xffffff, 0)
    this.img = scene.add.image(0, 0, 'tiles', 0).setDisplaySize(size, size)
    this.add([this.img, this.ring])
    scene.add.existing(this)
  }

  /** 정위치 지정(흔들림 후 복귀 기준). setPosition 대신 사용. */
  place(x: number, y: number) {
    this.homeX = x
    this.homeY = y
    this.setPosition(x, y)
  }

  setValue(v: number) {
    this.setVisible(v !== 0)
    if (v >= 1 && v <= 9) this.img.setFrame(v - 1)
  }

  setSelected(b: boolean) {
    this.ring.setStrokeStyle(this.ring.width * 0.06, 0xffef6b, b ? 1 : 0)
    this.setScale(b ? 1.06 : 1)
  }

  /** 인접 블록이 터질 때 (dx,dy) 방향으로 튕겼다가 스프링으로 복귀(물리 느낌). */
  nudge(dx: number, dy: number) {
    const len = Math.hypot(dx, dy) || 1
    const amp = this.size * 0.18
    const ox = (dx / len) * amp
    const oy = (dy / len) * amp
    this.scene.tweens.killTweensOf(this)
    this.setPosition(this.homeX, this.homeY)
    this.scene.tweens.add({
      targets: this,
      x: this.homeX + ox,
      y: this.homeY + oy,
      duration: 70,
      ease: 'Quad.easeOut',
      onComplete: () => {
        this.scene.tweens.add({
          targets: this, x: this.homeX, y: this.homeY,
          duration: 300, ease: 'Back.easeOut',
        })
      },
    })
  }

  /** 힌트: 굵은 초록 링 + 스케일 펄스(약 2.6초)로 합10 후보를 강조. */
  pulseHint() {
    this.scene.tweens.killTweensOf(this)
    this.setPosition(this.homeX, this.homeY)
    this.setScale(1)
    this.ring.setStrokeStyle(Math.max(5, this.size * 0.16), 0xffffff, 1)
    this.scene.tweens.add({
      targets: this, scaleX: 1.18, scaleY: 1.18,
      duration: 330, yoyo: true, repeat: 4, ease: 'Sine.easeInOut',
      onComplete: () => { this.setScale(1); this.ring.setStrokeStyle(this.ring.width * 0.06, 0xffef6b, 0) },
    })
  }

  async popOut(): Promise<void> {
    return new Promise(res => {
      this.scene.tweens.add({
        targets: this,
        scale: 0,
        alpha: 0,
        duration: 220,
        ease: 'Back.easeIn',
        onComplete: () => res(),
      })
    })
  }
}
